import clientInfo from 'common/lib/clientInfo';

export default function useCoupon(activeFeatures?: string[]) {
  if (activeFeatures === undefined) {
    return clientInfo.featureActive('comm_coupon_slug_for_popup_checkout')
      ? new URLSearchParams(window.location.search).get('coupon_code') || ''
      : '';
  }

  return activeFeatures.includes('comm_coupon_slug_for_popup_checkout')
    ? new URLSearchParams(window.location.search).get('coupon_code') || ''
    : '';
}
